import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Table, Tooltip } from "antd";
import {
  PlusOutlined,
  EditOutlined,
  SettingOutlined,
  UserAddOutlined,
  AuditOutlined,
  PrinterFilled,
  PrinterOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { UserInfo } from "../../../../context";
import InactiveEmployeeInfo from "./InactiveEmployeeInfo";
import PrintCOE from "./PrintCOE";
// import AddEmployee from "./AddEmployee";
// import EditEmployee from "./EditEmployee";
// import SetAccount from "./SetAccount";
// import SetPermission from "./SerPermission";
// import SetSchedule from "./SetSchedule";

const InactiveEmployeeList = ({
  // positionList,
  // rerun,
  // limit,
  unemployeeList,
  // getUnemployeeList,
}) => {
  // const [unemployeeList, setEmployeeList] = useState({
  //   data: [],
  //   ready: false,
  // });
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [editDrawer, setEditDrawer] = useState(false);
  const [setAccountDrawer, setSetAccountDrawer] = useState(false);
  const [setPermissionDrawer, setSetPermissionDrawer] = useState(false);
  const [scheduleDrawer, setScheduleDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [search, setSearch] = useState("");
  const [employeeInfoDrawer, setEmployeeInfoDrawer] = useState(false);
  const [coeDrawer, setCOEDrawer] = useState(false);
  const [openPrint, setOpenPrint] = useState(false);

  const columns = [
    {
      title: "User ID",
      dataIndex: "user_id",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Fullname",
      render: (text, record) => (
        <p>
          {text.lastname}, {text.firstname} {text.middle}
        </p>
      ),
    },
    {
      title: "Address",
      render: (text, record) => (
        <p style={{ textTransform: "uppercase" }}>
          {text.street}, {text.barangay}, {text.city}
        </p>
      ),
    },
    {
      title: "Contact #",
      dataIndex: "contact_no",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Position",
      dataIndex: ["merchantemployeeposition", "position"],
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 120,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 120 }}>
          <Tooltip title="Employee Info">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setEmployeeInfoDrawer(true);
              }}
              icon={<AuditOutlined />}
              style={{ marginRight: 5 }}
            />
          </Tooltip>

          <Tooltip title="Generate COE">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenPrint(true);
              }}
              icon={<PrinterOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  // const getUnemployeeList = useCallback(() => {
  //   var params = { user_id: userData.data.id, status: 1 };
  //   axios
  //     .get("user/merchant/employee-list", { params })
  //     .then((response) => {
  //       const data = response.data;
  //       setEmployeeList({ data, ready: true });
  //     })
  //     .catch((error) => {
  //       console.log("ERROR: ", error);
  //     });
  // }, [userData.data.id]);

  // useEffect(() => {
  //   getUnemployeeList();
  // }, [getUnemployeeList]);

  const searchable = unemployeeList.data.filter((data) => {
    return (
      data.lastname.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.firstname.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Input
            id="search"
            placeholder="Search name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>
        {/* <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setOpenDrawer(true)}
          disabled={unemployeeList.data.length >= parseInt(limit)}
        >
          Add Employee
        </Button> */}
      </div>

      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {/* {openDrawer && (
        <AddEmployee
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          rerun={() => getUnemployeeList()}
          positionList={positionList}
          limit={limit}
        />
      )} */}

      {/* {editDrawer && (
        <EditEmployee
          open={editDrawer}
          close={() => setEditDrawer(false)}
          setLoading={setLoading}
          rerun={() => getUnemployeeList()}
          selectedData={selectedData}
          positionList={positionList}
        />
      )} */}

      {/* {setAccountDrawer && (
        <SetAccount
          open={setAccountDrawer}
          close={() => setSetAccountDrawer(false)}
          setLoading={setLoading}
          rerun={() => getUnemployeeList()}
          selectedData={selectedData}
        />
      )} */}

      {/* {setPermissionDrawer && (
        <SetPermission
          open={setPermissionDrawer}
          close={() => setSetPermissionDrawer(false)}
          setLoading={setLoading}
          rerun={() => getUnemployeeList()}
          selectedData={selectedData}
        />
      )} */}

      {/* {scheduleDrawer && (
        <SetSchedule
          open={scheduleDrawer}
          close={() => setScheduleDrawer(false)}
          selectedData={selectedData}
        />
      )} */}

      {employeeInfoDrawer && (
        <InactiveEmployeeInfo
          open={employeeInfoDrawer}
          close={() => setEmployeeInfoDrawer(false)}
          selectedData={selectedData}
        />
      )}

      {/* OPEN PRINT EXPENSE */}
      {openPrint && (
        <PrintCOE
          open={openPrint}
          close={() => setOpenPrint(false)}
          selectedData={selectedData}

          // expenseFiltered={expenseFiltered}
          // totalFilteredExpense={totalFilteredExpense}
        />
      )}
    </>
  );
};

export default InactiveEmployeeList;
